import { integration } from "../integration";
import { store } from "../stores/mainStore";

export class HTTPServer {
	constructor(server){
		this.server = server;
	}

	CallRoute(route, payload, retryCount){
		retryCount = retryCount || 0;
		//Call a structured route
		let request = {
			"Route": route,
			"Payload": payload
		}
		store.setSpinner(true);
		return this.SendPacket(request)
		.then((response)=>{
			store.setSpinner(false);
			if(response.ErrorCode && response.ErrorCode !== 0){
				if(response.ErrorCode === 300011){
					console.log('repeat tutorial play');
					return response;
				}
				if(response.ErrorCode === 300019){
					console.log('let game retry roll');
					return response;
				}
				if(response.ErrorCode === 300023){
					console.warn('account already linked to a userid, login will overwite the user')
					return response;
				}
				if(response.ErrorCode === 300024 || response.ErrorCode === 300025){
					console.warn('Game action failed.')
					store.modal = 'opponentResigned';
					return response;
				}
				throw response;
			}
			return response;
		}).catch((err) => {
			store.setSpinner(false);
			if(retryCount === -1){
				//Do not retry. It is ok to fail.
			} else {
				if(!retryCount || retryCount < 2){
					console.warn(`Will Retry (${retryCount + 1})`, err);
					this.CallRoute(route, payload, retryCount+1);
				} else {
					integration.onError(`Server communication failed at route: ${route}`);
					store.errorMessage = `Server communication failed at route: ${route} ${JSON.stringify(err)}`;
					throw err;
				}
			}
		});
	}

	// setSpinner(on){
	// 	if(this.timer && !on){
	// 		clearTimeout(this.timer);
	// 	} else {
	// 		this.timer = setTimeout(() => {
	// 			store.setSpinner(on);
	// 		}, 500);
	// 	}
	// }

	SendImages(route, images){
		var formData = new FormData();
		// console.log(images);
		for(var image in images){
			formData.append(image, images[image]);
		}

		return fetch(this.server + "/" + route, {
			method:'POST',
			body: formData
		})
		.then(response => {
			return response.json();
		});

	}

	SendPacket(packet){
		if(packet.RequestId){
			console.error("Packet Sent with restricted Attribute MessageId");
			return new Promise((resolve, reject) => {
				reject({errorCode: 1, errorMessage: "Restricted Attribute Sent with Packet: MessageID"});
			});
		}

		//let messageId = this.sentMessageId ? this.sentMessageId++ : this.sentMessageId = 1;
		//packet.RequestId = messageId;

		if(this.token){
			packet.Token = this.token;
		}


		return fetch(this.server + "/interaction?route=" + packet.Route, {
			method:'POST',
			body: JSON.stringify(packet)
		})
		.then(response => {
			return response.json()
			.then((data) => {
				if(data.Payload && data.Payload.Token){
					// console.log('token set', data.Payload.Token);
					this.token = data.Payload.Token
				}
				return data;
			});
		});
	}

	SendRaW(rawData){
		//This should not be used in production unless there is an extraordinary
		//There are rules for the server -> client communication

	}

	SetToken(token){
		this.token = token;
	}
}
